<template>
  <div></div>
  <!--  <CFooter :fixed="false">
    <div>
      <span class="ml-1">&copy; {{ new Date().getFullYear() }} Panne.tn</span>
    </div>
    <div class="ml-auto">
      <span class="mr-1">Powered by</span>
      <a href="https://panne.tn/" target="_blank">Panne.tn</a>
    </div>
  </CFooter> -->
</template>

<script>
export default {
  name: "TheFooter",
};
</script>
